import SocialLink from './social-link';

export default SocialLink;
